import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";

import * as notifications from "notifications";
import {
  Select,
  EditorField,
  FormCollapsible,
  SubmitButton,
  PhoneInput,
  TextInput,
  BooleanSelect,
} from "components/forms";
import { createFunderContactAffiliation, editFunderContactAffiliation, fetchFunderContact } from "actions";
import {
  activeFunderContactIdSelector,
  activeFunderContactAffiliationSelector,
  managementChoicesSelector,
  activeFunderIdSelector,
} from "reducers";
import { getFromFunderDetail, partial } from "utils";
import { FUNDER_CONTACT_AFFILIATION_STATUS } from "../../../accounts/constants";

const FunderContactAffiliationForm = ({
  activeFunderContactAffiliation,
  activeFunderContactId,
  activeFunderId,
  ...props
}) => {
  const fromFunderDetail = getFromFunderDetail();
  fromFunderDetail && activeFunderContactId && props.fetchFunderContact(activeFunderContactId);
  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...activeFunderContactAffiliation,
        funder_contact: fromFunderDetail ? activeFunderContactAffiliation.funder_contact : activeFunderContactId,
        funder: fromFunderDetail ? activeFunderId : activeFunderContactAffiliation.funder,
      }}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        const method = isEmpty(activeFunderContactAffiliation)
          ? props.createFunderContactAffiliation
          : partial(props.editFunderContactAffiliation);

        try {
          await method(values);
          props.fetchFunderContactAffiliationsFromFunder(activeFunderId);
        } catch (error) {
          setErrors(error.response.data);
          notifications.error("Error editing Affiliation");
        }
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <FormCollapsible onSubmit={handleSubmit} title="Affiliation Detail">
            <Form.Row>
              <Select
                label="Funder"
                name="funder"
                options={props.funderChoices.getChoices()}
                disabled={fromFunderDetail}
              />
              <Select
                label="Funder Contact"
                name="funder_contact"
                options={props.funderContactChoices.getChoices()}
                disabled={!fromFunderDetail}
              />
              <Select
                label="Affiliation Status"
                name="status"
                placeholder="Select Affiliation Status"
                options={FUNDER_CONTACT_AFFILIATION_STATUS}
              />
            </Form.Row>
            <Form.Row>
              <PhoneInput label="Company Phone" name="company_phone" />
              <TextInput label="Company Email" lowercase={true} name="company_email" />
              <TextInput label="Title" name="title" />
              <BooleanSelect label="Company Email Opt Out" name="email_opt_out" inline={true} />
            </Form.Row>
            <Form.Row>
              <EditorField label="Notes" name="notes" />
            </Form.Row>
            <SubmitButton />
          </FormCollapsible>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);
  return {
    funderChoices: choices.funders,
    funderContactChoices: choices.funder_contacts,
    activeFunderId: activeFunderIdSelector(state),
    activeFunderContactId: activeFunderContactIdSelector(state),
    activeFunderContactAffiliation: activeFunderContactAffiliationSelector(state),
  };
};

export default connect(mapStateToProps, {
  fetchFunderContact,
  createFunderContactAffiliation,
  editFunderContactAffiliation,
})(FunderContactAffiliationForm);
